import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { OffreEmploi } from '../models/offreEmploi.model';

@Injectable({
    providedIn: 'root'
})
export class OffreEmploiService {
    apiUrl = environment.apiUrl;
    offreEmploi: OffreEmploi;
    offresEmploi: OffreEmploi[];

    constructor(private http: HttpClient) { }

    getOne(id_offre_emploi: number): Observable<OffreEmploi> {
        const params = new HttpParams().set('id_offre_emploi', id_offre_emploi.toString());
        return this.http.get(`${this.apiUrl}/offre_emploi`, { params: params }).pipe(
            map((res) => {
                this.offreEmploi = res['data'];
                return this.offreEmploi;
            }),
        catchError(this.handleError));
    }

    getAllByIdInstance(id_instance: number): Observable<OffreEmploi[]> {
        const params = new HttpParams().set('id_instance', id_instance.toString());
        return this.http.get(`${this.apiUrl}/offres_emploi`, { params: params }).pipe(
            map((res) => {
                this.offresEmploi = res['data'];
                return this.offresEmploi;
            }),
        catchError(this.handleError));
    }

    getAll(): Observable<OffreEmploi[]> {
        return this.http.get(`${this.apiUrl}/offres_emploi`).pipe(
            map((res) => {
                this.offresEmploi = res['data'];
                return this.offresEmploi;
            }),
        catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
